import { render, staticRenderFns } from "./NoOrdersFound.vue?vue&type=template&id=5f2622f1&"
import script from "./NoOrdersFound.vue?vue&type=script&lang=js&"
export * from "./NoOrdersFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports